import type { ModuleUISlot, SmrtModuleMeta } from '@happyvertical/smrt-types';

export const CHAT_UI_SLOTS: Record<string, ModuleUISlot> = {
  'chat-layout': {
    id: 'chat-layout',
    label: 'Chat Layout',
    description: 'Discord/Slack-style chat layout with sidebar',
    icon: 'message-square',
    category: 'display',
    order: 1,
    propsInterface: 'ChatLayoutProps',
  },
  'room-list': {
    id: 'room-list',
    label: 'Room List',
    description: 'Sidebar room navigation with unread badges',
    icon: 'list',
    category: 'list',
    order: 2,
    propsInterface: 'RoomListProps',
  },
  'message-list': {
    id: 'message-list',
    label: 'Message List',
    description: 'Scrollable chat message feed',
    icon: 'message-circle',
    category: 'list',
    order: 3,
    propsInterface: 'MessageListProps',
  },
  'message-input': {
    id: 'message-input',
    label: 'Message Input',
    description: 'Chat message input with attachments',
    icon: 'edit-2',
    category: 'form',
    order: 4,
    propsInterface: 'MessageInputProps',
  },
  'chat-tabs': {
    id: 'chat-tabs',
    label: 'Chat Tabs',
    description: 'Facebook-style expandable chat tabs',
    icon: 'columns',
    category: 'display',
    order: 5,
    propsInterface: 'ChatTabsProps',
  },
  'agent-chat': {
    id: 'agent-chat',
    label: 'Agent Chat',
    description: 'Full agent conversation interface',
    icon: 'bot',
    category: 'display',
    order: 6,
    propsInterface: 'AgentChatProps',
  },
  'thread-panel': {
    id: 'thread-panel',
    label: 'Thread Panel',
    description: 'Threaded conversation side panel',
    icon: 'git-branch',
    category: 'display',
    order: 7,
    propsInterface: 'ThreadPanelProps',
  },
};

export const CHAT_MODULE_META: SmrtModuleMeta = {
  name: '@happyvertical/smrt-chat',
  displayName: 'Chat',
  description: 'Real-time chat rooms, DMs, threads, and agent conversations',
  uiSlots: CHAT_UI_SLOTS,
  models: [
    'ChatRoom',
    'ChatThread',
    'ChatMessage',
    'ChatParticipant',
    'ChatReaction',
    'AgentSession',
    'VoiceSession',
  ],
  collections: [
    'ChatRoomCollection',
    'ChatThreadCollection',
    'ChatMessageCollection',
    'ChatParticipantCollection',
    'ChatReactionCollection',
    'AgentSessionCollection',
    'VoiceSessionCollection',
  ],
};
